import { IKnoOrganization } from 'APIPackage/CatalogsModule/interfaces/IKnoOrganization';

import { IKnoOrganisationSelectOption } from '../interfaces/IKnoOrganisationSelectOption';

export const createKnoOrganisationSelectOption = (knoOrganization: IKnoOrganization): IKnoOrganisationSelectOption => ({
  ...knoOrganization,
  label: knoOrganization.fullName,
  value: knoOrganization.id,
});
